import { useContext } from 'react';
import { FeatureContext } from 'core/context/feature.context';

const useFeatureContext = () => useContext(FeatureContext);

export default useFeatureContext;